import { CreateExtractTasksMode } from '~src/extract/actions/CreateExtractTaskAction';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';

import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IRefreshExtractAction } from '../../../../ts/ServerApi/types/actionNames';
import { createExtractRefresh } from '../../../actions/spaces/CreateExtractRefreshAction';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { anyItemIsEmbeddedDatasource } from './IEntityActionHelpers';

export const RefreshExtractsAction: IEntityAction<IContentInfo, IRefreshExtractAction> = {
  name: EntityActionNames.RefreshExtracts,
  translateName: Messages.extractTasks_action,
  isVisible: (targetItems: IContentInfo[]) => {
    return !anyItemIsEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: IRefreshExtractAction, targetItems: IContentInfo[]) => {
    return targetItems.length > 1 || !!(availableActions && availableActions.refreshExtract);
  },
  createReduxAction: (targetItems: IContentInfo[]) => createExtractRefresh(targetItems,
    getSessionManagementServiceInstance().isOnlineEnvironment() ?
    CreateExtractTasksMode.AllowRefreshNowAndOnServerAndClient : CreateExtractTasksMode.AllowRefreshNowAndOnServer)
};
